(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/brands/assets/javascripts/brands-hashmap.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/brands/assets/javascripts/brands-hashmap.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => __WEBPACK_DEFAULT_EXPORT__

  }); 


  const definedEmblem = 'vinnare';
  const path = '/images/ui/brands/';
  const cdn = window.svs && window.svs.core && window.svs.core.config && window.svs.core.config.data && window.svs.core.config.data.svsconfig ? window.svs.core.config.data.svsconfig.cdn : '';
  const hashedBrands = {
    '17ellermer': {
      svg: '17ellermer-8220536e3cba30c9b0c6e53631ad081e6963a3d9.svg',
      alt: '17 eller mer'
    },
    '3irad': {
      svg: '3irad-7027e1179a1bee3f0b8dd6106fa28b2a954be4d1.svg',
      alt: '3 i rad'
    },
    'bil-triss': {
      svg: 'bil-triss-ae60b17601f0f29205a5cb7a665ec2d25bab6204.svg',
      alt: 'BilTriss'
    },
    bingo: {
      svg: 'bingo-364e62c2905e5c0b77a80bd711b459694f5a428e.svg',
      alt: 'Bingo'
    },
    bomben: {
      svg: 'bomben-87237b46214238de027327037de997001ec9683f.svg',
      alt: 'Bomben'
    },
    'bomben-100': {
      svg: 'bomben-100-5e550e1a5952ec94757954b3d81427db1eed5cdf.svg',
      alt: 'Bomben'
    },
    casino: {
      svg: 'casino-8d124e9018517abe59e9aac219391c26ae58d9db.svg',
      alt: 'Casino'
    },
    challenge: {
      svg: 'challenge-99148550c540b5775286ff571bfaa2e2e31c9cfd.svg',
      alt: 'Challenge'
    },
    'challenge-100': {
      svg: 'challenge-100-4adcfe50908f5f80f89e23a4aa8ea96dd54bf3db.svg',
      alt: 'Challenge'
    },
    'dubbel-triss': {
      svg: 'dubbel-triss-aaa6726f86bf72e31ae4f08d33c4a367c0c3dea4.svg',
      alt: 'DubbelTriss'
    },
    'em-tipset': {
      svg: 'em-tipset-972e88778d5412f74fbe78e1590b318a469de220.svg',
      alt: 'EM-Tipset'
    },
    eurojackpot: {
      svg: 'eurojackpot-960c7f3881d1bd589ac2c5ecabb904b8a2ba2aaf.svg',
      alt: 'Eurojackpot'
    },
    'eurojackpot-100': {
      svg: 'eurojackpot-100-ef7f364c93ddb8b8cb338e9f17fc532c28ae2512.svg',
      alt: 'Eurojackpot'
    },
    europatipset: {
      svg: 'europatipset-afdb5fc30f60e94d92e47cbba47008cb11496feb.svg',
      alt: 'Europatipset'
    },
    extratipset: {
      svg: 'extratipset-2244dedb76f5e63c19b65b7d6a3c63a599ea3acc.svg',
      alt: 'Extratipset'
    },
    'fler-lotter': {
      svg: 'fler-lotter-8ef841793f1c260b4850bae930b9e4cdfaf416dc.svg',
      alt: 'Fler lotter'
    },
    grasroten: {
      svg: 'grasroten-c3142448932624ae03afece9cc4bb867aa2e90ac.svg',
      alt: 'Gräsroten'
    },
    keno: {
      svg: 'keno-96d200f518ffd2edcfdd8e811a4d6d9b34878f12.svg',
      alt: 'Keno'
    },
    kenoxpress: {
      svg: 'kenoxpress-7228d0212f0862b9b26182ed5aada0f49b086731.svg',
      alt: 'KenoXpress'
    },
    'kenoxpress-full': {
      svg: 'kenoxpress-full-a0175caca35b14656b0603fc02cbe821e2c07100.svg',
      alt: 'KenoXpress'
    },
    langen: {
      svg: 'langen-c5bf797b814cc8a926631d040633f555eb3ec7c1.svg',
      alt: 'Lången'
    },
    'langen-100': {
      svg: 'langen-100-9bc33e7409ea3f79aca0271fda74e3e68ffd8de0.svg',
      alt: 'Lången'
    },
    langenxl: {
      svg: 'langenxl-b996bf11d2544f02ed061146d6c6fb36c5550577.svg',
      alt: 'Lången XL'
    },
    'langenxl-100': {
      svg: 'langenxl-100-f6792521bf59eac0214bc5bdfaba6ae6b62eb9af.svg',
      alt: 'Lången XL'
    },
    live: {
      svg: 'live-9d16a795f4e89a292a215fd88fd0464131e05896.svg',
      alt: 'Live'
    },
    'live-100': {
      svg: 'live-100-0f323c05e6b98b22f781eb8939009481bce132c6.svg',
      alt: 'Live'
    },
    'live-casino': {
      svg: 'live-casino-3fe8add031f62da568c042acadb65d4a93236e9e.svg',
      alt: 'Live Casino'
    },
    lordagsgodis: {
      svg: 'lordagsgodis-5240bba50669c0d781599f501591596265f3a2da.svg',
      alt: 'Lördagsgodis'
    },
    'lordagsgodis-oneline': {
      svg: 'lordagsgodis-oneline-104a6831a632825bfdf9629c9e367adea3fc4d86.svg',
      alt: 'Lördagsgodis'
    },
    'lordagsgodis-oneline-red': {
      svg: 'lordagsgodis-oneline-red-3a11c99db6c1ecefdb7defc42473f67e19f90635.svg',
      alt: 'Lördagsgodis'
    },
    'lordagsgodis-red': {
      svg: 'lordagsgodis-red-957ead92208ace8289dad1aec8a38e4b8e517043.svg',
      alt: 'Lördagsgodis'
    },
    lotto: {
      svg: 'lotto-1ef4a5390343182da07b647ed7950767341b895c.svg',
      alt: 'Lotto'
    },
    maltipset: {
      svg: 'maltipset-317e6051667412b74a3be4e7045f1d1a9e60fba1.svg',
      alt: 'Måltipset'
    },
    matchen: {
      svg: 'matchen-a8823462913490376020418b12e7a69d2e527aa9.svg',
      alt: 'Matchen'
    },
    'matchen-100': {
      svg: 'matchen-100-0d5c47941d593f630dd4e57e5eef10e63d17d89f.svg',
      alt: 'Matchen'
    },
    'mini-triss': {
      svg: 'mini-triss-4278ba1b65a0729c70939e377503a436fc8de52b.svg',
      alt: 'MiniTriss'
    },
    mittemellan: {
      svg: 'mittemellan-89ff00d6f47ea7d9e6800c00442e1855c3c7c8bf.svg',
      alt: 'Mittemellan'
    },
    mixen: {
      svg: 'mixen-9bc58caebf317d726f14815c4f8b457e464a0959.svg',
      alt: 'Mixen'
    },
    'mixen-100': {
      svg: 'mixen-100-87a503e81af4e1c7a272511e2df29a64a2449d74.svg',
      alt: 'Mixen'
    },
    mixenxl: {
      svg: 'mixenxl-4b35065655613d208b6551e889b93e9b8f7eb85a.svg',
      alt: 'Mixen XL'
    },
    'mixenxl-100': {
      svg: 'mixenxl-100-e333885766e6799740e12023b575ee2c190fc8a3.svg',
      alt: 'Mixen XL'
    },
    oddset: {
      svg: 'oddset-0152f8bdc64a8ce4fe3dbbfee5682d86ed72f8b3.svg',
      alt: 'Oddset'
    },
    'oddset-100': {
      svg: 'oddset-100-7a0a7e47e503830572277b85e0a5ad20db62d5d2.svg',
      alt: 'Oddset'
    },
    poker: {
      svg: 'poker-7ae287318ad3df4639b8bde15f83a54ff20e2e79.svg',
      alt: 'Poker'
    },
    powerplay: {
      svg: 'powerplay-679543e871f0291f948fadf51299ddd1d976e357.svg',
      alt: 'Powerplay'
    },
    'powerplay-100': {
      svg: 'powerplay-100-4dab416c61fe82d498e70274864d6e7bc4f8d93f.svg',
      alt: 'Powerplay'
    },
    rubbet: {
      svg: 'rubbet-ac8801d527323453818c8a6bf931b1144f97a1e3.svg',
      alt: 'Rubbet'
    },
    rubbetcom: {
      svg: 'rubbetcom-769a02fb41fdbd34b90751433444dcb86b45fe06.svg',
      alt: 'Rubbet'
    },
    'skrap-bingo': {
      svg: 'skrap-bingo-c89eaeb55006cdeffc0ae0c8c2a7c7369c817430.svg',
      alt: 'SkrapBingo'
    },
    'skrap-kryss': {
      svg: 'skrap-kryss-be3db3931b5b699dc792f3b3b687cd7c24860709.svg',
      alt: 'SkrapKryss'
    },
    'skrap-matcha': {
      svg: 'skrap-matcha-b0acae7a63494430bc844af9ba1c2ab0c756d7be.svg',
      alt: 'SkrapMatcha'
    },
    'skrap-neg': {
      svg: 'skrap-neg-6eee22e7e9c9b4d11c98fc7e1c24326af413b386.svg',
      alt: 'Skrap'
    },
    'skrap-pacman': {
      svg: 'skrap-pacman-2c1230d4d0654dcf42a8385bd1a7027963138f2d.svg',
      alt: 'Skrap-PAC-MAN'
    },
    skrap7an: {
      svg: 'skrap7an-c682a237e790608b72147bd78714363712428ec4.svg',
      alt: 'Skrap7:an'
    },
    skrapspel: {
      svg: 'skrapspel-76a09f9532a810d0f0e9adf978addf31d35a576f.svg',
      alt: 'Skrapspel'
    },
    stryktipset: {
      svg: 'stryktipset-1b04842c82f34822a825a13ec93705e19960d29e.svg',
      alt: 'Stryktipset'
    },
    svenskaspel: {
      svg: 'svenskaspel-8db894b7a8eaf023f9289d34785746ca6d8cc41b.svg',
      alt: 'Svenska Spel'
    },
    'svenskaspel-100': {
      svg: 'svenskaspel-100-f557ed205672c7b631ac3c6d22ed9194429f70a0.svg',
      alt: 'Svenska Spel'
    },
    'svenskaspel-twolines': {
      svg: 'svenskaspel-twolines-8db878efa4dbf8a8c75ee66dd8357dbfe92f1ff9.svg',
      alt: 'Svenska Spel'
    },
    'svenskaspel-twolines-neg': {
      svg: 'svenskaspel-twolines-neg-f4f73f25e0f1c79afa5c8a0a5b8f682702753c9c.svg',
      alt: 'Svenska Spel'
    },
    topptipset: {
      svg: 'topptipset-63b6e53db400dc066f9b483e009f6a6328e03d4d.svg',
      alt: 'Topptipset'
    },
    'trav-galopp': {
      svg: 'trav-galopp-a289ecc11b09f7e458bc43904eaad55ad1bc0b99.svg',
      alt: 'Trav &amp; Galopp'
    },
    'trav-galopp-primary': {
      svg: 'trav-galopp-primary-e1ff57e45f5a7166145029e41e3872f3fccdfd3a.svg',
      alt: 'Trav &amp; Galopp'
    },
    'trav-galopp-secondary': {
      svg: 'trav-galopp-secondary-d5292db0507a800fb12a2619a472dd58e27dd6a8.svg',
      alt: 'Trav &amp; Galopp'
    },
    triss: {
      svg: 'triss-ceb33df005fc7a587efdc4aa0b38533085475dfd.svg',
      alt: 'Triss'
    },
    vikinglotto: {
      svg: 'vikinglotto-c22be7a7312b994b45e7337b10bae354f6393a8c.svg',
      alt: 'Vikinglotto'
    },
    vinnare: {
      svg: 'vinnare-ff0e5b270033fe4ddeb67049a1c2fdebc7183a13.svg',
      alt: ''
    },
    'vinnare-new': {
      svg: 'vinnare-new-ff0e5b270033fe4ddeb67049a1c2fdebc7183a13.svg',
      alt: ''
    },
    'vm-tipset': {
      svg: 'vm-tipset-2244dedb76f5e63c19b65b7d6a3c63a599ea3acc.svg',
      alt: 'VM-Tipset'
    }
  };
  const guards = {
    '17-eller-mer': '17ellermer',
    '3-i-rad': '3irad',
    biltriss: 'bil-triss',
    netcasino: 'casino',
    dubbeltriss: 'dubbel-triss',
    skrapkeno: 'keno',
    'skrap-keno': 'keno',
    'live casino': 'live-casino',
    'lotto onsdag': 'lotto',
    'lotto-onsdag': 'lotto',
    'lotto lordag': 'lotto',
    'lotto-lordag': 'lotto',
    skraplotto: 'lotto',
    'skrap-lotto': 'lotto',
    minitriss: 'mini-triss',
    'mitt-emellan': 'mittemellan',
    mixen: 'oddset',
    langen: 'oddset',
    sportsbook: 'oddset',
    skrapbingo: 'skrap-bingo',
    skrapkryss: 'skrap-kryss',
    skrapmatcha: 'skrap-matcha',
    'skrap-neg': 'skrap-neg',
    'skrap-pac-man': 'skrap-pacman',
    'skrap-7an': 'skrap7an',
    skrappyramid: 'skrapspel',
    'skrap-familjen': 'skrapspel',
    skrapstjarna: 'skrapspel',
    'trav--galopp-secondary': 'trav-galopp-secondary',
    'trav--galopp-primary': 'trav-galopp-secondary',
    'trav--galopp': 'trav-galopp',
    'triss-familjen': 'triss',
    'triss-30': 'triss',
    'triss-40': 'triss',
    'triss-90': 'triss',
    'triss-150': 'triss',
    'triss-premium': 'triss'
  };

  const getGuard = brand => {
    let match = brand.trim().replace(/[ÅÄåä]/g, 'a').replace(/[Öö]/g, 'o').replace(/Éé/g, 'e').replace(/ /g, '-').replace(/[^A-Za-z0-9_-]/g, '').toLowerCase();

    if (guards[match]) {
      match = guards[match];
    }

    return match;
  };

  const getBrand = (brand, size) => {
    let hashedStr = getGuard(brand);
    const guardedBrand = hashedStr;

    if (hashedBrands[hashedStr] && size > 0) {
      hashedStr = hashedBrands["".concat(hashedStr, "-").concat(size)] ? "".concat(hashedStr, "-").concat(size) : hashedStr;
    }

    return {
      brand: guardedBrand,
      svg: hashedBrands[hashedStr].svg,
      alt: hashedBrands[hashedStr].alt
    };
  };

  const getEmblem = () => hashedBrands[definedEmblem].svg;

  const getAssetUrl = brand => cdn + path + brand;


  const __WEBPACK_DEFAULT_EXPORT__ = {
    getAssetUrl,
    getBrand,
    getEmblem
  };
  ((window.svs = window.svs || {}).ui = window.svs.ui || {}).brands = __webpack_exports__.default;
})();
 })(window);